<template>
  <div id="my-process-index" :class="{ 'main-container': isHome }">
    <el-tabs v-model="tabName" @tab-click="changeTab" v-if="isHome">
      <el-tab-pane :label="`待我审批(${todoCount || 0})`" name="myPedding"></el-tab-pane>
      <el-tab-pane
        :label="`我发起的(${startCount || 0})`"
        name="myStart"
      ></el-tab-pane>
      <el-tab-pane
        :label="`我审批的(${approvedCount || 0})`"
        name="myApprove"
      ></el-tab-pane>
      <!-- <el-tab-pane
        :label="`草稿(${draftCount})`"
        name="myDraft"
      ></el-tab-pane> -->
    </el-tabs>
    <div :class="{ 'info-content': isHome }">
      <transition name="fade-transform" mode="out-in">
        <router-view
          :isHome="isHome"
          ref="routerView"
          @changeTodoCount="changeTodoCount"
          @changeStartCount="changeStartCount"
          @changeApprovedCount="changeApprovedCount"
        />
          <!-- :type-list="typeList" -->
          <!-- @changeDraftCount="changeDraftCount" -->
      </transition>
    </div>
  </div>
</template>

<script>
import { getNum, 
  // getOriTree, // 原本没有使用
} from "./home-page-request";
import MyPedding from "./myPedding/Index"; // 待办
import MyStart from "./myStart/Index"; // 我发起的
import MyApprove from "./myApprove/Index"; // 我审批的
export default {
  name: "myProcessIndex",
  components: {
    MyPedding, // 待办
    MyStart, // 我发起的
    MyApprove, // 我审批的
  },
  data() {
    return {
      isHome: true, // 是否是tab页
      tabName: "myPedding", // 当前tab页
      processNum: {
        todoCount: 0, // 待我审批的
        startCount: 0, // 我发起的
        approvedCount: 0, // 我审批的
        draftCount: 0, // 草稿
      }, // tab页旁边的数字集合
      // primaryBudgetList: [], // 一级部门列表
      todoCount: 0,
      startCount: 0,
      approvedCount: 0,
      draftCount: 0, // 草稿
      initTodoCount: -1,
    };
  },
  watch: {
    $route(to, from) {
      this.tabName = to.name; // 监控路由 当点击面包屑时 路由变为待办 tab页也跳到待办
      let flag =
        this.tabName === "myPedding" ||
        this.tabName === "myApprove" ||
        this.tabName === "myStart" ||
        this.tabName === "myDraft";
      this.isHome = flag ? true : false;
      if (this.$refs.routerView && this.$refs.routerView.isHome) {
        this.$refs.routerView.isHome = flag ? true : false;
      } 
      this.setIsHome()
      // this.queryProcessNum();
      // console.log("this.isHome", this.isHome)
    },
  },
  created() {
    this.tabName = this.$route.name ? this.$route.name : "myPedding";
    // this.queryProcessNum(); // 获取tab页旁边的数字 如：待办(12)  我发起的(3)
    // this.getOriTree();
    this.setIsHome()
    // this.queryApplyStatusList()
  },
  methods: {
    setIsHome() {
      let flag =
        this.tabName === "myPedding" ||
        this.tabName === "myApprove" ||
        this.tabName === "myStart" ||
        this.tabName === "myDraft";
        this.isHome = flag ? true : false;
        if ( this.$refs.routerView && this.$refs.routerView.isHome) {
          this.$refs.routerView.isHome = flag ? true : false;
        }
    },
    // changeDraftCount(val) { // 获取草稿箱
    //   this.draftCount = val;
    //   this.queryProcessNum();
    // },
    changeApprovedCount(val) {
      this.approvedCount = val;
      this.queryProcessNum();
    },
    changeStartCount(val) {
      this.startCount = val;
      this.queryProcessNum();
    },
    changeTodoCount(val) {
      this.initTodoCount = val;
      this.todoCount = val;
      this.queryProcessNum();
    },
    /**
     * @description 切换tab页
     * @author wangjiaqun 044033
     * @param {Object} tab tab标签对象
     */
    changeTab(tab) {
      this.todoCount = this.initTodoCount >= 0 ? this.initTodoCount : 0;
      this.startCount = this.processNum.submitedNum;
      this.approvedCount = this.processNum.approvedNum;
      // this.draftCount = this.processNum.draftCount;
      
      this.$router.push(`/myProcess/myProcessIndex/${this.tabName}`);
    },
    /**
     * @description 获取tab页旁边的数字 如：待办(12)  我发起的(3)
     * @author wangjiaqun 044033
     */
    async queryProcessNum() {
      const params = {
        nodeId: this.$store.state.userInfo.curRole.nodeId, // 组织架构id
        staffId: this.$store.state.userInfo.id, // 员工id
        roleId: this.$store.state.userInfo.curRole.roleId, // 角色id
      };
      let res = await getNum(params);
      if (res.data) {
        this.processNum = Object.assign({}, this.processNum, res.data);
        this.todoCount = this.processNum.todoNum
        this.startCount = this.processNum.submitedNum;
        this.approvedCount = this.processNum.approvedNum;
        // this.draftCount = this.processNum.draftCount;
      }
    },
    /**
     * @description 获取一级预算部门
     * @author wangjiaqun
     */
    // async getOriTree() {
    //   //  查询的数据类型 1全部组织架构[主体-归属-责任中心-一级部门-事业部][不做数据权限控制] 2科目[不做数据权限控制] 3半年度【预算周期】 4年度【预算周期】5组织架构[主体-归属-责任中心-一级部门][做数据权限控制] 6一级部门[做数据权限控制] 7科目[做数据权限控制]
    //   const params = {
    //     dataType: 6
    //   };
    //   let res = await getOriTree(params);
    //   if( res.data && res.data.tree) {
    //     const primaryBudgetList = res.data.tree || [];
    //     this.primaryBudgetList = primaryBudgetList.filter(item=>{
    //       return item.mapid !== 0 && item.mapid !== '0'
    //     })
    //   }
    // },
  },
};
</script>